import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { LogIn, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND } from "@/config/brand";

const NAV = [
  { href: "#corridors", label: "Locations" },
  { href: "#advantage", label: "Why Brickspace" },
  { href: "#process", label: "How it works" },
  { href: "#faq", label: "FAQ" },
];

export const Header = () => {
  const [solid, setSolid] = useState(false);

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 90);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid ? "glass-light" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-[1280px] items-center justify-between px-5 py-4 lg:px-8">
        <a href="#top" data-testid="brand-logo" className="flex items-center gap-2">
          <span
            className={`font-display text-xl font-extrabold tracking-[-0.03em] ${
              solid ? "text-ink" : "text-white"
            }`}
          >
            brickspace<span className="text-brand">.</span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-${item.href.replace("#", "")}`}
              className={`text-sm font-medium transition-colors ${
                solid ? "text-body hover:text-brand" : "text-white/75 hover:text-white"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2.5">
          <Link
            to="/crm/login"
            data-testid="header-crm-login"
            className={`flex items-center gap-1.5 rounded-full px-3 py-2 text-sm font-semibold transition-colors ${
              solid ? "text-ink hover:bg-cloud" : "text-white/85 hover:text-white"
            }`}
          >
            <LogIn className="h-4 w-4" />
            <span className="hidden sm:inline">Advisor login</span>
          </Link>
          <a
            href={`tel:${BRAND.phone}`}
            data-testid="header-call-btn"
            className="flex items-center gap-2 rounded-full bg-brand px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-brandDark"
          >
            <Phone className="h-4 w-4" />
            <span className="hidden sm:inline">{BRAND.phoneDisplay}</span>
            <span className="sm:hidden">Call</span>
          </a>
        </div>
      </div>
    </motion.header>
  );
};
